import { NavigationContainer, NavigationLogoSection, NeveLogoLink, StyledNeveLogo } from './Navigation';
import strings from '../../strings/strings.json';
import styled from 'styled-components';
import { sizes } from 'theme';
import LoginIcon from 'assets/icons/navigation/LoginIcon';
import { IconSize } from 'assets/icons/icon-sizes';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from 'contextProviders/AuthContext';
import Button from 'components/buttons/Button';

export default function NavigationPublic(): JSX.Element {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <NavigationContainer>
            <RowContent>
                <NavigationLogoSectionPublic>
                    <NeveLogoLink to={'/'}>
                        <StyledNeveLogo
                            alt={strings.appHeader.neveLearningLogoAltText}
                            aria-label={strings.appHeader.neveLearningLogoAria}
                        />
                    </NeveLogoLink>
                </NavigationLogoSectionPublic>
                <Button
                    title={strings.loginPage.submitButton}
                    aria={strings.loginPage.submitButtonAriaLabel}
                    onClick={() => navigate('/signin', { state: { redirect: location.pathname } })}
                    icon={<LoginIcon size={IconSize.SMALL} />}
                />
            </RowContent>
        </NavigationContainer>
    );
}

export function NavigationSignOutOnly(): JSX.Element {
    const navigate = useNavigate();
    const { signOutNeve } = React.useContext(AuthContext);
    const [signingOut, setSigningOut] = React.useState(false);

    async function signOutClick() {
        try {
            setSigningOut(true);
            await signOutNeve();
            navigate('/');
        } finally {
            setSigningOut(false);
        }
    }

    return (
        <NavigationContainer>
            <RowContent>
                <NavigationLogoSectionPublic>
                    <NeveLogoLink to={'/'}>
                        <StyledNeveLogo
                            alt={strings.appHeader.neveLearningLogoAltText}
                            aria-label={strings.appHeader.neveLearningLogoAria}
                        />
                    </NeveLogoLink>
                </NavigationLogoSectionPublic>
                <Button
                    title={strings.signOutButton}
                    aria={strings.signOutButton}
                    onClick={signOutClick}
                    icon={<LoginIcon size={IconSize.SMALL} />}
                    submitting={signingOut}
                    colour='PRIMARY'
                />
            </RowContent>
        </NavigationContainer>
    );
}

const NavigationLogoSectionPublic = styled(NavigationLogoSection)`
    border-bottom: unset;
`;

const RowContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: ${sizes.appMaxWidthWithoutPadding}px;
    height: 100%;
    padding: 0 ${sizes.edgePadding};
`;
